import script from "./AllUsers.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllUsers.vue?vue&type=script&setup=true&lang=ts"

import "./AllUsers.vue?vue&type=style&index=0&id=ab1f430e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab1f430e"]])

export default __exports__